import { Link, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { Library, CalendarDays, ShieldCheck } from "lucide-react";

// Tab bar partagée entre /admin/sets et /admin/schedule pour permettre de switcher
// sans repasser par le dashboard /admin. L'onglet "All Sets" n'apparaît que pour
// les super-admins (ADMIN_USER_IDS côté serveur) — il pointe sur /admin/all-sets
// qui liste les sets de tous les users et permet d'éditer / supprimer n'importe quel.
export function AdminSubnav({ isAdmin = false }: { isAdmin?: boolean }) {
  const { pathname } = useLocation();
  const tabs = [
    { to: "/admin/sets", label: "Question Sets", icon: Library, adminOnly: false },
    { to: "/admin/schedule", label: "My Schedule", icon: CalendarDays, adminOnly: false },
    { to: "/admin/all-sets", label: "All Sets", icon: ShieldCheck, adminOnly: true },
  ];

  return (
    <motion.div
      initial={{ y: -10, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ delay: 0.05 }}
      className="mb-6 flex gap-1 p-1 bg-white/60 backdrop-blur-md rounded-full border-2 border-sakura-100/60 shadow-kawaii-card w-fit"
    >
      {tabs.filter(t => !t.adminOnly || isAdmin).map(({ to, label, icon: Icon }) => {
        const active = pathname === to || (to !== "/admin/sets" && pathname.startsWith(to));
        // Cas particulier pour /admin/sets : éviter de matcher /admin/all-sets via startsWith.
        const activeSets = to === "/admin/sets" && pathname === "/admin/sets";
        const finalActive = active || activeSets;
        return (
          <Link
            key={to}
            to={to}
            className={`flex items-center gap-1.5 px-4 py-1.5 rounded-full text-xs font-black transition-all ${
              finalActive
                ? "bg-gradient-to-r from-sakura-400 to-lavender-400 text-white shadow-kawaii"
                : "text-lavender-500 hover:bg-lavender-100/60"
            }`}
          >
            <Icon className="w-3.5 h-3.5" />
            {label}
          </Link>
        );
      })}
    </motion.div>
  );
}
